import React from 'react'
import { apiFetch } from '../../fetchApi'

export const summaryDetails = ({ BeURL, profileSummary, address, candidateId, navigate, setLoading, showAlert }) => {
    apiFetch(`${BeURL}/summaryInformation`, {
        method: 'POST',
        body: JSON.stringify({ profileSummary, address, candidateId })
    })
        .then(res => res.json())
        .then(data => {
            setLoading(false)
            if (data.success) {
                showAlert(data.message)
                window.location.href = `/update-account/education?candidateId=${candidateId}`
            }
            else {
                showAlert(data.message)
            }
        })
        .catch(err => {
            setLoading(false)
            console.log('Error in summary and address details:', err)
            showAlert('Trouble in connecting to the Server! Please try again later.')
        })

}
